// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	GoToVacantTaxAdjustmentLink: 'go-to-vacant-tax-adjustment-link',
	VacantHomeTaxApplicableCheckbox: 'vacant-home-tax-applicable-checkbox',
	JurisdictionSearchDropdown: 'jurisdiction-search-dropdown',
	PrimaryJurisdictionPill: 'primary-jurisdiction-pill',
	Toast: 'toast',
	GoToLttSpan: 'go-to-ltt-span',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
